import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {agreementConfirmination} from '../../../../actions/agreement.actions';
import {
  Button,
  ButtonGroup,
  PageContainer,
  PageDescription,
  PageSubTitle,
  PageTitle,
  StepBox,
} from '../../../Common/PageComponents';

class PrintKitRequestAgreement extends Component {
  _cancel(e) {
    e.preventDefault();
    this.props.history.push('/news/tournament-kit');
  }

  _request(e) {
    e.preventDefault();
    this.props.dispatch(agreementConfirmination('printKit'));
    this.props.history.push('/news/tournament-kit/print-kit-request');
  }

  render() {
    return (
      <PageContainer>
        <PageTitle title="토너먼트 키트 신청" />
        <PageSubTitle title="프린트 키트 신청" />
        <StepBox activeIndex={0} steps={['이용약관동의', '신청서작성', '신청완료']} />
        <PageDescription>실물 키트 신청을 위해 아래 약관에 동의하셔야 합니다.</PageDescription>
        <div className="join_kit_box">
          <strong>“리그 오브 레전드 프린트 키트” 운영 정책</strong>
          <br />
          <br />
          <dl>
            <dt>■</dt>{' '}
            <dd>
              리그 오브 레전드 프린트 키트 (이하 “프린트 키트”)는 리그 오브 레전드 가맹 PC방 (이하 “가맹 PC방”)에서
              자체적으로 진행하는 토너먼트(게임대회)를 지원할 목적으로 라이엇 게임즈에서 제작한 전용 홍보물입니다.
            </dd>
            <dt>■</dt>{' '}
            <dd>
              본 프린트 키트는 비상업적 용도의 가맹 PC방에서 자체적으로 진행되는 토너먼트를 위해서만 사용하실 수
              있습니다.
            </dd>
            <dt>■</dt>{' '}
            <dd>
              PC방 토너먼트에 대한 상세한 규정은 토너먼트 신청 페이지내 대회 규정 및 진행방법 안내를 참조하시기
              바랍니다.
              <br />
              <br />
            </dd>
            <b>
              <dt>①</dt> <dd>신청 자격 및 방법</dd>
            </b>
            <span className="indent_l">
              <dt>1)</dt>{' '}
              <dd>대한민국에 위치한 리그 오브 레전드 가맹 PC방에 한해 PC방 홈페이지를 통해 신청 가능합니다.</dd>
              <dt>2)</dt>{' '}
              <dd>개인 또는 판매 등을 위한 상업적 용도를 위해서는 본 프린트 키트를 신청하실 수 없습니다.</dd>
            </span>
            <b>
              <dt>②</dt> <dd>선정 및 배송 방법</dd>
            </b>
            <span className="indent_l">
              <dt>1)</dt> <dd>매월 200개 PC방에 선착순으로 제공됩니다.</dd>
              <dt>2)</dt> <dd>배송은 담당 영업사원의 방문 또는 우편으로 전달됩니다.</dd>
              <dt>3)</dt>{' '}
              <dd>
                토너먼트 시작일 2주전에 신청이 완료되어야 개최일에 맞춰 배송이 가능합니다.
                <br />
                <br />
              </dd>
            </span>
            <b>
              <dt>③</dt> <dd>프린트 키트 구성</dd>
            </b>
            <span className="indent_l">
              <dt>1)</dt> <dd>토너먼트용 대진표 – 3종 중 택일, 2매 지급</dd>
              <dt>2)</dt>{' '}
              <dd>
                PC방 자체 토너먼트 홍보용 포스터 – 가로형 2매
                <br />
                <br />
              </dd>
            </span>
            <b>
              <dt>④</dt> <dd>프린트 키트 일반규정</dd>
            </b>
            <span className="indent_l">
              <dt>1)</dt>{' '}
              <dd>
                본 프린트 키트의 저작권은 Riot Games, Inc. 및 라이엇 게임즈 코리아의 소유로, 대한민국의 법률 및 관련
                국제법률과{' '}
                <a
                  href="http://www.leagueoflegends.co.kr/?m=rules&cid=1&dt=2018-08-05"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  리그 오브 레전드 최종 사용자 라이센스 계약
                </a>
                에 준하여 보호됩니다.
              </dd>
              <dt>2)</dt>{' '}
              <dd>
                본 프린트 키트는 어떠한 경우에도 판매, 가공, 복사, 교환, 전송, 양도, 배포, 2차 저작물 제작 등을 하실 수
                없으며, 단순한 PC방 자체 토너먼트의 홍보 목적으로만 사용하실 수 있습니다.
              </dd>
              <dt>3)</dt>{' '}
              <dd>
                본 디지털 키트의 사용과 관련된 문의는 PC방 고객센터를 통해 전달해주시기 바랍니다.
                <br />
                <br />
              </dd>
            </span>
            <dd>
              본 양식에 PC방명,사업자등록번호,주소,대표자명,연락처를 기재하여 제출하는 것은 라이엇 게임즈 코리아 및 본
              행사를 진행하는 ㈜손오공 IB에 제공됩니다. 따라서 라이엇 게임즈 코리아 및 ㈜손오공 IB에 정보제공을 원하지
              않으신다면,본 프린트 키트의 신청을 삼가 주시기를 부탁 드립니다. 등록하신 개인정보는 본 프린트 키트의
              제공을 위해서만 사용되며, 프린트 키트 제공 등 목적을 다한 이후 복구할 수 없는 방법을 통해 삭제됩니다.
              <br />
            </dd>
          </dl>
        </div>
        <ButtonGroup>
          <Button onClick={e => this._request(e)}>동의 및 신청</Button>
          <Button theme="gray" onClick={e => this._cancel(e)}>
            취소
          </Button>
        </ButtonGroup>
      </PageContainer>
    );
  }
}

export default withRouter(connect()(PrintKitRequestAgreement));
